module.exports = __webpack_public_path__ + "img/ic_service.c880c5f4.svg";